import WarningSolidSVG from "@design-system/ui-icons/vanilla/WarningSolid"
import { createIcon } from "../createIcon"

export const WarningSolidIcon = createIcon(WarningSolidSVG)
